import { Component, OnDestroy, OnInit } from "@angular/core";
import { filter, Observable, Subscription, take } from "rxjs";
import { MapHelperService } from "src/services/map-helper.service";
import { TutorialService } from "src/app/features/ui/organisms/tutorial/services/tutorial.service";
import { SessionService } from "src/app/features/shared/services/Session.service";
import { BaseMapService } from "src/app/features/pages/maps/services/BaseMap.service";
import { GeofencesService } from "../../../../services/Geofences.service";
import { GeofencesMapService } from "../../../../services/GeofencesMap.service";

@Component({
  selector: "geofences-section",
  templateUrl: "./geofences-section.component.html",
  styleUrls: ["./geofences-section.component.css"],
})
export class GeofencesMapComponent implements OnInit, OnDestroy {
  public isLoading: boolean = true;
  public $isLoading: Observable<boolean> = new Observable<boolean>();
  public IsAuthenticated = false;
  public _isVisiblePinbar: boolean;
  public _isVisibleNavBar: boolean;
  public _isVisiblePanelGeofences: boolean;
  public _isVisiblePanelEditGeofences: boolean;
  public _isVisiblePanelDetailGeofences: boolean;
  private _CENTER_LAT = "24.226252";
  private _CENTER_LNG = "-103.0266765";
  private _CENTER_ZOOM = "4.5";
  dataGeoJsonLocations: any;
  private $isVisiblePanelGeofences: Observable<boolean>;
  private $isVisiblePanelEditGeofences: Observable<boolean>;
  private $isVisiblePanelDetailGeofences: Observable<boolean>;
  subscription_GetLoading: Subscription;
  subscription_SetLocationsGeoJson: Subscription;
  subscription_checkAuthenticated: Subscription;
  Subscription_GetMapMainSource: Subscription;
  isVisiblePanelGeofences: Subscription;
  isVisiblePanelAddGeofences: Subscription;
  isVisiblePanelEditGeofences: Subscription;
  isVisiblePanelDetailGeofences: Subscription;
  isAdmin: any;
  isMapUnified: boolean;

  constructor(
    private geofencesService: GeofencesService,
    private sessionService: SessionService,
    private mapHelperService: MapHelperService,
    private tutorialService: TutorialService,
    private baseMapService: BaseMapService,
    private geofencesMapService: GeofencesMapService
  ) {
    this.$isVisiblePanelGeofences = this.geofencesService.getVisiblePanelGeofences();
    this.isVisiblePanelGeofences = this.$isVisiblePanelGeofences.subscribe((data) => {
      this._isVisiblePanelGeofences = data;
      setTimeout(() => {
        if (this._isVisiblePanelGeofences != undefined && this._isVisiblePanelGeofences == true) {
          this.tutorialService.startTutorial(["panelGeofencesTutorial"]);
        }
      }, 1000);
    });

    this.$isVisiblePanelEditGeofences = this.geofencesService.getVisiblePanelEditGeofences();
    this.isVisiblePanelEditGeofences = this.$isVisiblePanelEditGeofences.subscribe((data) => {
      this._isVisiblePanelEditGeofences = data;
    });

    this.$isVisiblePanelDetailGeofences = this.geofencesService.getVisiblePanelDetailGeofences();
    this.isVisiblePanelDetailGeofences = this.$isVisiblePanelDetailGeofences.subscribe((data) => {
      this._isVisiblePanelDetailGeofences = data;
      setTimeout(() => {
        if (this._isVisiblePanelDetailGeofences != undefined && this._isVisiblePanelDetailGeofences == true) {
          this.tutorialService.startTutorial(["panelGeofenceDetailTutorial"]);
        }
      }, 1000);
    });
    this.geofencesService.setVisiblePanelDetailGeofences(false);
    this.isMapUnified = false;
  }

  ngOnInit(): void {
    this.CheckingSourceURL();
    this.StartMap();

    this.subscription_GetLoading = this.geofencesService
      .getLoading()
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });
    this._isVisiblePinbar = true;
  }

  ngOnDestroy() {
    if (this.subscription_SetLocationsGeoJson)
      this.subscription_SetLocationsGeoJson.unsubscribe();
    if (this.subscription_GetLoading)
      this.subscription_GetLoading.unsubscribe();
    if (this.subscription_checkAuthenticated)
      this.subscription_checkAuthenticated.unsubscribe();
    if (this.isVisiblePanelGeofences)
      this.isVisiblePanelGeofences.unsubscribe();
    if (this.isVisiblePanelAddGeofences)
      this.isVisiblePanelAddGeofences.unsubscribe();
    if (this.isVisiblePanelEditGeofences)
      this.isVisiblePanelEditGeofences.unsubscribe();
    if (this.isVisiblePanelDetailGeofences)
      this.isVisiblePanelDetailGeofences.unsubscribe();
    if (this.Subscription_GetMapMainSource)       
      this.Subscription_GetMapMainSource.unsubscribe();
  }

  

  CheckingSourceURL() {
    this.sessionService.CheckURLSource();
    this._isVisibleNavBar = this.sessionService.isMapix;
  }

  StartMap() {
    this._isVisiblePinbar = true;
    this._isVisiblePanelGeofences = false;
    this._isVisiblePanelEditGeofences = false;
    this._isVisiblePanelDetailGeofences = false;
    // this.geofencesMapService.LoadMapGeofences();

    this.Subscription_GetMapMainSource = this.mapHelperService.mainSource$.pipe(
                filter(map => map && map.isMainSourceReady && map.isStyleReady), take(1) ).subscribe(async map => {
      if (map && map.isMainSourceReady && map.isStyleReady ) {
        this.geofencesMapService.LoadMapGeofences();
        this.mapHelperService.mapResize();
      }
    });

    // this.baseMapService.addEventOnMapLoad(async () => {
    //   this.geofencesMapService.LoadMapGeofences();
    // });
  }
  
}
